import React, { useRef } from 'react';
import { Box, Card, Typography, CardMedia } from '@mui/material';
import {RAW_FILES_URL} from "../utils";

const recommendedApps = [
    {
        id: 1,
        name: 'Voice Assistant',
        description: 'An AI-powered voice assistant app for automating tasks.',
        imageUrl: RAW_FILES_URL + '/kb-image/13zgksgv3d5q.png?v=25',
    },
    {
        id: 2,
        name: 'Image Recognizer',
        description: 'Leverage AI to identify and categorize images.',
        imageUrl: RAW_FILES_URL + '/kb-image/19mzeg95kowl.png?v=25',
    },
    {
        id: 3,
        name: 'Language',
        description: 'Translate text between multiple languages in real-time.',
        imageUrl: RAW_FILES_URL + '/kb-image/1nofey882lu2.png?v=25',
    },
    {
        id: 4,
        name: 'Chatbot',
        description: 'Integrate a smart conversational chatbot into your service.',
        imageUrl: RAW_FILES_URL + '/kb-image/1fk5moyeeu18.png?v=25',
    }
];

export const RecommendedApps = () => {
    const handleInstall = () => {
        alert('Todo Install')
    };

    return (
        <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden', padding: 2 }} style={{ padding: 0, paddingLeft: 20 }}>
            <Box
                sx={{ overflowX: 'auto', display: 'flex', whiteSpace: 'nowrap' }}
                style={{ padding: 0, margin: 0 }}
            >
                {recommendedApps.map((app, index) => (
                    <Box key={index} sx={{ width: 50, marginRight: 2, marginBottom: 2 }}>
                        <Card sx={{ width: 50, height: 50, position: 'relative', cursor: 'pointer' }} onClick={handleInstall}>
                            <CardMedia
                                component="img"
                                image={app.imageUrl}
                                alt={app.name}
                                sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            />
                        </Card>
                        <Typography
                            variant="caption"
                            align="center"
                            sx={{
                                mt: 1,
                                fontSize: 9,
                                whiteSpace: 'normal', // Allows text to wrap
                                lineHeight: '1.2',   // Adjust line height for better readability
                                height: '2.4em',     // Set a fixed height to accommodate two lines
                                overflow: 'hidden',  // Hide overflow text
                                textOverflow: 'ellipsis', // Add an ellipsis to text that overflows
                                display: '-webkit-box',
                                WebkitLineClamp: 2,  // Limit text to two lines
                                WebkitBoxOrient: 'vertical'
                            }}
                        >
                            {app.name}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

